import { useMemo } from "react";
import type { TagItem } from "src/queries/tags/tags.types";
import { MAX_TAGS_PER_GROUP } from "../../AssetsFilterTags.constants";

export const useTagVisibility = (tags: TagItem[]) => {
  return useMemo(() => {
    const totalCount = tags.length;
    const visibleTags = tags.slice(0, MAX_TAGS_PER_GROUP);
    const hasMore = totalCount > MAX_TAGS_PER_GROUP;
    const hiddenCount = Math.max(0, totalCount - MAX_TAGS_PER_GROUP);

    return {
      visibleTags,
      totalCount,
      hasMore,
      hiddenCount,
    };
  }, [tags]);
};
